import {PaymentMethodType} from 'components/manufacturer/Payments/entity/Setting';
import {camelizeKeys} from 'humps';

export enum CardType {
    card_domestic = 'card_domestic',
    card_international = 'card_international',
    invoice = 'invoice',
    account = 'account',
}

interface PaymentMethodApiResponse {
    base_amount: number;
    deposit_percentage: number;
    full_amount: number;
    payment_method: CardType;
    payment_type: string;
    platform_fee: number;
    platform_fee_tax_amount: number;
    remaining_balance: number;
    surcharge_amount: number;
    surcharge_applied: boolean;
    surcharge_tax_amount: number;
    tax_amount: number;
    total_tax_amount: number;
    total_with_surcharge: number;
}

export interface PaymentMethod {
    paymentMethod?: CardType;
    baseAmount?: number;
    fullAmount?: number;
    depositPercentage?: number;
    platformFee?: number;
    surchargeAmount?: number;
    taxAmount?: number;
    platformFeeTaxAmount?: number;
    surchargeTaxAmount?: number;
    totalTaxAmount?: number;
    totalWithSurcharge?: number;
    surchargeApplied?: boolean;
    paymentType?: PaymentMethodType;
    remainingBalance?: number;
}

export interface PaymentOptionsApiResponse {
    gateway: {
        payment_methods: PaymentMethodApiResponse[];
    };
    invoice: {
        payment_methods: PaymentMethodApiResponse[];
    };
}

export interface PaymentSessionApiResponse {
    client_secret: string;
    payment_intent_id: string;
    connected_account_id: string;
    base_amount: number;
    currency: 'AUD' | 'NZL';
    payment_method_type: CardType;
    default_payment_method_type: PaymentMethodType;
    payment_options: PaymentOptionsApiResponse;
}

export interface PaymentOptions {
    gateway: {
        paymentMethods: PaymentMethod[];
    };
    invoice: {
        paymentMethods: PaymentMethod[];
    };
    account?: {
        paymentMethods: PaymentMethod[];
    };
}

export interface PaymentSession {
    clientSecret: string;
    paymentIntentId: string;
    connectedAccountId: string;
    baseAmount: number;
    currency: 'AUD' | 'NZL';
    defaultPaymentMethodType: CardType;
    paymentOptions: PaymentOptions;
}

export const mapPaymentType = <
    T extends {payment_options?: PaymentOptionsApiResponse},
>(
    data: T
) => {
    if (data?.payment_options?.gateway?.payment_methods) {
        data.payment_options.gateway.payment_methods =
            data.payment_options.gateway.payment_methods.map((method) => {
                if (method.payment_type == 'deposit') {
                    method.payment_type = PaymentMethodType.CARD_DEPOSIT;
                } else if (method.payment_type == 'full') {
                    method.payment_type = PaymentMethodType.CARD_FULL;
                }

                return method;
            });
    }

    if (data?.payment_options?.invoice?.payment_methods) {
        data.payment_options.invoice.payment_methods =
            data.payment_options.invoice.payment_methods.map((method) => {
                if (method.payment_type == 'deposit') {
                    method.payment_type = PaymentMethodType.INVOICE_DEPOSIT;

                    // NOTE: This might need to come from BE later for this can stay for now
                    if (method.remaining_balance == undefined) {
                        const totalTax = method.full_amount / 11;
                        const totalExTax = method.full_amount - totalTax;

                        const depositToalExTax =
                            method.base_amount - method.tax_amount;

                        method.remaining_balance =
                            (totalExTax - depositToalExTax) * 1.1;
                    }
                    // NOTE: This might need to come from BE later for this can stay for now
                } else if (method.payment_type == 'full') {
                    method.payment_type = PaymentMethodType.INVOICE_FULL;
                }

                return method;
            });
    }

    return data;
};

export const mapPaymentSession = (data: PaymentSessionApiResponse) => {
    return camelizeKeys(mapPaymentType(data)) as PaymentSession;
};
